module.exports = __webpack_public_path__ + "img/视频封面10.97061581.png";